import { get_paywalls_state_config } from '../base';

export default get_paywalls_state_config({
    url: '/win_rate_unique',
    title: 'Win Rate Unique',
    template: require('./view.html'),
    service_method_name: 'win_rate_unique_by_mission_range',
    is_missions_required: false,
});
